import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchEnabledFlagValues = async () => await fetch(
  Config.endpoints.FETCH_ENABLED_FLAG_VALUES
)
  .then(handleErrors({ errorMessage: 'Fetching enabled flag failed' }))
  .then(parseAsJson);

export const fetchUsTaxTypes = async () => await fetch(Config.endpoints.FETCH_US_TAX_TYPES)
  .then(handleErrors({ errorMessage: 'Fetching Tax types failed' }))
  .then(parseAsJson);

export const fetchLocalTaxTypes = async () => await fetch(Config.endpoints.FETCH_LOCAL_TAX_TYPES)
  .then(handleErrors({ errorMessage: 'Fetching Tax types failed' }))
  .then(parseAsJson);

export const fetchCountries = async () => await fetch(Config.endpoints.FETCH_COUNTRIES)
  .then(handleErrors({ errorMessage: 'Fetching Countries failed' }))
  .then(parseAsJson);

export const fetchLegalEntities = async ({ periodName }) => await fetch(
  Config.endpoints.FETCH_LEGAL_ENTITIES.replace(/:periodName/, periodName))
  .then(handleErrors({ errorMessage: 'Fetching Countries failed' }))
  .then(parseAsJson);
